import '@updater-components/icon';
import '@updater-components/radio-group';
import template from './phone.html';
import { actions, selectors } from '../../../../state';
import './phone.global.css';

const INVALID_PHONE_TYPES = ['VOIP', 'PREPAID'];
const VERIFY_MESSAGE = `The name or address associated with this number doesn't match the information on your Updater account.`;

const getPhoneTypeMessage = (phoneType) =>
  `Looks like you're using a ${phoneType} phone. We really want to, but our lawyers won’t let us use a ${phoneType} phone for identity verification.`;

const isInvalidPhoneType = (phoneType) =>
  INVALID_PHONE_TYPES.includes(phoneType);

const DELIVERY_METHODS = {
  SMS: 'sms',
  CALL: 'call',
};

class VerifyPhoneController {
  constructor($state, $element, $timeout, updStore) {
    'ngInject';
    Object.assign(this, {
      updStore,
      $element,
      $timeout,
      smsValue: DELIVERY_METHODS.SMS,
      callValue: DELIVERY_METHODS.CALL,
      phoneLength: 10,
      $state,
    });
  }

  $onInit() {
    this.disconnect = this.updStore.connect(mapStateToThis)(this);
  }

  $postLink() {
    this.modal = this.$element.find('upd-dialog')[0];
  }

  $onDestroy() {
    this.disconnect();
  }

  onVerify({ deliveryMethods, verifiedPhone, errors }) {
    if (deliveryMethods && !!deliveryMethods.length) {
      this.verifiedPhone = verifiedPhone;
      this.deliveryMethod = deliveryMethods.includes(DELIVERY_METHODS.SMS)
        ? DELIVERY_METHODS.SMS
        : DELIVERY_METHODS.CALL;
    } else {
      this._openModal({
        title: () => `Sorry, we can't verify your identity with this number.`,
        message: () => getVerifyErrorMessage((errors[0] || {}).code),
      });
    }
  }

  onPhoneChange(value) {
    if ((value || '').length < this.phoneLength) {
      this.deliveryMethod = null;
    }
  }

  onDeliveryMethodChange(e) {
    this.deliveryMethod = e.target.value;
  }

  _openModal(resolve) {
    this.modalTitle = resolve.title();
    this.modalMessage = resolve.message();
    this.modal.showModal();
  }

  _closeModal() {
    this.modal.close();
    this.retry();
  }

  retry() {
    this.phone = null;
    this.deliveryMethod = null;

    this.$timeout(() => {
      const phoneInput = document.querySelector('input#phone');
      phoneInput.focus();
    });
  }

  sendCode(deliveryMethod, phoneNumber) {
    const { dispatch } = this.updStore;

    const success = (response) => {
      dispatch(
        actions.router.stateGo('.code', {
          phone_number: phoneNumber,
          delivery_method: deliveryMethod,
        })
      );
      dispatch(actions.analytics.track('Sent Verify Code'));
    };
    const error = (response) => {
      this._openModal({
        title: () => 'Sorry.',
        message: () =>
          `We can’t verify your identity with this phone number right now. Please try another number or try again later.`,
      });
      dispatch(
        actions.analytics.track('Tried To Send Verify Code', {
          Errors: response.payload.errors,
        })
      );
    };

    dispatch(
      actions.phoneVerification.requestPin({
        move_id: this.moveId,
        phone_number: phoneNumber,
        delivery_method: deliveryMethod,
      })
    ).then(success, error);
  }
}

export const VerifyPhoneComponent = {
  template,
  controller: VerifyPhoneController,
};

function mapStateToThis(state) {
  return {
    moveId: selectors.current.move(state).id(state),
    sendingCode: selectors.pending.match(
      actions.phoneVerification.isRequestPin,
      state
    ),
  };
}

function getVerifyErrorMessage(phoneType) {
  return isInvalidPhoneType(phoneType)
    ? getPhoneTypeMessage(phoneType)
    : VERIFY_MESSAGE;
}
